import React from "react";
import { Link } from "react-scroll";
import { useParallax } from "react-scroll-parallax";
import VideoMp4 from "../assets/videos/hero0.mp4";

export const Hero = () => {
  const titleParallax = useParallax({
    scale: [0.8, 1.2],
    opacity: [0.5, 1],
    easing: "easeOutQuad",
  });

  const subtitleParallax = useParallax({
    translateY: [50, 0],
    opacity: [0, 1],
    easing: "easeOutCubic",
  });

  const descriptionParallax = useParallax({
    translateY: [30, 0],
    opacity: [0, 1],
    easing: "easeOutCubic",
  });

  const buttonParallax = useParallax({
    translateY: [100, 0],
    opacity: [0, 1],
    easing: "easeOutCubic",
  });

  return (
    <section name="home" className="relative w-full h-screen flex flex-col justify-center mb-0 pb-0">
      <div className="absolute z-0 w-full h-full">
        <video
          id="bg_video"
          autoPlay={true}
          muted loop
          playsInline={true}
          className="absolute w-full h-full object-cover bg-black opacity-80"
        >
          <source src={VideoMp4} type="video/mp4" />
        </video>
      </div>

      <div className="absolute top-0 left-0 bottom-0 right-0 bg-black opacity-50" />

      <div className="absolute h-full w-full flex items-center z-[1] px-4">
        <div className="w-full max-w-6xl" style={{ marginLeft: '80px' }}>
          <div className="p-16 w-full rounded-2xl backdrop-blur-sm bg-black bg-opacity-30 shadow-2xl text-left">
            <h2 
              ref={titleParallax.ref} 
              className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl py-4 md:py-6 font-bold text-white bg-gradient-to-r from-blue-400 to-purple-600 bg-clip-text text-transparent leading-tight ml-12"
            >
              Valiant
            </h2>
            <h3 
              ref={subtitleParallax.ref} 
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mt-4 mb-6 leading-tight ml-4"
            >
              Dealflow Cracked
            </h3>
            <p 
              ref={descriptionParallax.ref} 
              className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white mb-8 md:mb-12 leading-relaxed ml-4"
            >
              End-to-end Ai workflow for investment research
            </p>
            <div 
              ref={buttonParallax.ref}
            >
              <Link 
                className="text-xl sm:text-2xl md:text-3xl hover:cursor-pointer text-white bg-transparent py-4 md:py-6 px-8 md:px-12 border-4 inline-block hover:bg-blue-600 hover:border-blue-600 transition-all duration-300" 
                to="about" 
                smooth={true} 
                offset={0} 
                duration={500}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
